// Power Dialer aus dem Listenkopf starten. Das Telefonie-Modul stellt (sobald fertig) `dialerStarten(viewId, modus)`
// bereit (jetzt vorhanden); fehlt sie, gilt `useTelefonie().dialerStarten(viewId, { modus, kurz })`.
// Die Klingeldauer-Wahl „kurz/normal“ aus „Verwalten“ wird je Smart View im Browser gemerkt.
import { useCallback } from "react";
import * as telefonie from "../../telefonie";
import { useTelefonie } from "../../telefonie";

export type DialerModus = "weiter" | "von_vorn";
export type Klingeldauer = "kurz" | "normal";

type ExternStart = (viewId: string, modus: DialerModus, optionen?: { kurz?: boolean | null; klingeldauer?: number | null }) => Promise<void>;
const extern = (telefonie as unknown as Record<string, unknown>).dialerStarten as ExternStart | undefined;

const SCHLUESSEL = "crm-dialer-klingeldauer:";

export function klingeldauerLesen(viewId: string): Klingeldauer {
  try {
    return localStorage.getItem(SCHLUESSEL + viewId) === "kurz" ? "kurz" : "normal";
  } catch {
    return "normal";
  }
}

export function klingeldauerSetzen(viewId: string, wahl: Klingeldauer): void {
  try {
    if (wahl === "kurz") localStorage.setItem(SCHLUESSEL + viewId, "kurz");
    else localStorage.removeItem(SCHLUESSEL + viewId);
  } catch {
    /* ohne Speicher gilt „normal“ */
  }
}

export function useDialerStart(): {
  starten: (viewId: string, modus: DialerModus) => Promise<void>;
  bereit: boolean;
  grund: string | undefined;
  laeuftFuer: string | null;
  pausiert: boolean;
  weiter: () => Promise<void>;
} {
  const t = useTelefonie();
  const aus = t.status === "nicht_eingerichtet" || t.status === "initialisiert" || !!t.aktiverAnruf;
  const starten = useCallback(
    async (viewId: string, modus: DialerModus) => {
      const kurz = klingeldauerLesen(viewId) === "kurz";
      if (extern) return extern(viewId, modus, { kurz });
      return t.dialerStarten(viewId, { modus, kurz });
    },
    [t],
  );
  return {
    starten,
    bereit: !aus,
    grund: aus ? (t.grund ?? undefined) : undefined,
    laeuftFuer: t.dialer && !t.dialer.sitzung.beendet ? t.dialer.sitzung.smart_view_id : null,
    pausiert: !!t.dialer?.pausiert,
    weiter: t.dialerWeiter,
  };
}
